import React, { useEffect, useState } from 'react';
import { CollapsibleTopicBlock } from '../components';
import { useSelector } from 'react-redux';

const TopicSection = ({ data: { topics, documents } }) => {
  const miniCart = useSelector((state) => new Set(state.cart.miniCart));
  const ownedProducts = useSelector((state) => new Set(state.cart.ownedProducts));

  topics.sort((a, b) => a.node.name.localeCompare(b.node.name));
  return (
    <div id="FAQ">
      <div className="container">
        <div className="w-layout-grid faq-grid">
          {topics.map((topic) => {
            let topicData = [];
            let documentState = 'buy';
            topicData.title = topic.node.name;
            topicData.documents = documents.filter((document) => {
           

              for (let i = 0; i < document.node.documentTopic.length; i++) {
                if (document.node.documentTopic[i].id === topic.node.id) {
                  return true;
                }
              }
            });

            return (
              <CollapsibleTopicBlock
                data={topicData}
                key={topic.node.id}
                miniCart={miniCart}
                ownedProducts={ownedProducts}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export { TopicSection };
